<template>
  <div class="invoice-form" v-loading="loading">
    <invoice :invoice="invoice" />
    <div class="invoice-controls">
      <el-button type="danger" icon="el-icon-close" @click="$emit('close')">Cancel invoice</el-button>
      <el-button type="primary" icon="el-icon-check" @click="sendInvoice">{{ charge ? 'Charge' : 'Accept' }} and send</el-button>
    </div>
  </div>
</template>

<script>
import Invoice from '@/components/front/invoice/Invoice'

export default {
  name: 'InvoiceForm',
  components: { Invoice },
  props: {
    from: Date,
    to: Date,
    charge: Boolean,
    dueDate: Date,
    data: Object
  },
  data () {
    return {
      loading: false,
      selection: true,
      createdAt: new Date(),
    }
  },
  computed: {
    invoice () {
      let items = this.createFakeInvoiceItems(this.data)
      return {
        total: this.data.transactions.reduce((a, b) => a.amount + b.amount, 0) + this.data.model.monthlyFee,
        from: this.from,
        to: this.to,
        paid: this.charge,
        createdAt: new Date(),
        dueDate: this.dueDate,
        organization: this.data.organization,
        items: items,
        creditCardBrand: this.data.organization.card ? this.data.organization.card.brand : null,
        creditCardLast4: this.data.organization.card ? this.data.organization.card.last4 : null,
        creditCardExp: this.data.organization.card ? this.data.organization.card.expirationMonth + '/' + this.data.organization.card.expirationYear : null
      }
    }
  },
  methods: {
    showInvoice (charge) {
      if (charge) {
        this.charge = true
        setTimeout(() => {
          this.selection = false
        }, 250)
      }
    },
    createFakeInvoiceItems (data) {
      let items = []
      data.transactions.forEach(t => {
        items.push({
          description: t.user.name + ' refilled '
            + t.description + ' @ '
            + t.station.name + ' - '
            + t.amount.toString() + ' '
            + data.organization.currency.name + ' ('
            + t.rate.toString() + '%)',
          amount: t.amount * (t.rate / 100),
          currency: data.organization.currency.name
        })
      })
      items.push({
        description: 'Monthly platform operation fee',
        amount: data.model.monthlyFee,
        currency: data.organization.currency.name
      })

      return items
    },
    async sendInvoice () {
      this.loading = true
      const data = {
        organizationId: this.data.organization.id,
        start: this.from.getFullYear() + '-' + (this.from.getMonth() + 1) + '-' + this.from.getDate(),
        end: this.to.getFullYear() + '-' + (this.to.getMonth() + 1) + '-' + this.to.getDate(),
        dueDate: this.dueDate.getFullYear() + '-' + (this.dueDate.getMonth() + 1) + '-' + this.dueDate.getDate(),
        paid: this.charge
      }
      const response = await this.$http.post(this.$api.invoices.create, data)
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .invoice-controls {
    background-color: white;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
      flex: 1;
      height: 60px;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/billing-overview/InvoiceForm.vue